import React from 'react';
import styled, { css } from 'styled-components';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';

const imageByVariant = {
    signIn: '/assets/images/signin-background.jpg',
    createPartner: '/assets/images/partner-background.jpg',
};

function Background({ variant }) {
    const isSignIn = variant === 'signIn';
    const isPartner = variant === 'createPartner';

    return (
        <BackgroundContainer $vivid={isSignIn || isPartner}>
            <BackgroundImage
                $vivid={isSignIn}
                $partner={isPartner}
                src={imageByVariant[variant] || '/assets/images/background.jpg'}
                alt=''
            />
            {isSignIn && <Overlay />}
            {isPartner && <PartnerOverlay />}
        </BackgroundContainer>
    )
};

const BackgroundContainer = styled.div`
    display: none;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
        height: 100%;
        width: 100%;
        background: ${({ $vivid }) => $vivid ? colors.secondary : colors.occasionalBlue};
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        overflow: hidden;
    }
`;

const BackgroundImage = styled.img`
    width: 100%;
    height: 100%;
    opacity: .3;
    object-fit: cover;
    filter: blur(5px);

    /* Enquadramento do layout de referência: foto ampliada e deslocada para a
       pessoa em primeiro plano ficar perto do texto. */
    ${({ $vivid }) => $vivid && css`
        --frame-scale: 110%; --frame-left: -13.1%; --frame-top: -4%;
        position: absolute;
        left: var(--frame-left);
        top: var(--frame-top);
        width: var(--frame-scale);
        height: var(--frame-scale);
        max-width: none;
        opacity: 1;
        filter: none;
    `}

    /* A foto ocupa só a área à esquerda do painel (entrando por baixo da curva
       dele), presa à esquerda: assim a pessoa no notebook e o palco ficam no
       quadro e o pôr do sol encosta no painel, como no layout. */
    ${({ $partner }) => $partner && css`
        position: absolute;
        left: 0;
        top: 0;
        width: calc(100% - max(36.9375%, 500px) + 60px);
        height: 100%;
        object-position: left center;
        opacity: 1;
        filter: saturate(1.15);
    `}
`;

const Overlay = styled.div`
    position: absolute;
    inset: 0;
    background:
        linear-gradient(90deg, rgba(12, 14, 30, .75) 0%, rgba(16, 14, 34, .5) 35%, rgba(30, 18, 60, .12) 65%, transparent 100%),
        radial-gradient(ellipse 400px 200px at 80px 100%, rgba(132, 72, 245, .55) 0%, rgba(132, 72, 245, 0) 100%),
        linear-gradient(0deg, rgba(30, 10, 70, .35) 0%, transparent 35%);
`;

const PartnerOverlay = styled.div`
    position: absolute;
    inset: 0;
    background:
        linear-gradient(90deg, rgba(6, 5, 26, .72) 0%, rgba(8, 6, 32, .5) 38%, rgba(20, 10, 50, .12) 62%, transparent 80%),
        linear-gradient(0deg, rgba(4, 3, 20, .82) 0%, rgba(6, 4, 26, .45) 32%, transparent 58%),
        linear-gradient(180deg, rgba(20, 10, 70, .25) 0%, transparent 30%);
`;

export default Background;
